import {
  DialogProps,
  DialogTitle,
  Dialog as DialogMui,
  styled,
  Box,
  IconButton,
} from "@mui/material"
import { IoClose } from "react-icons/io5"

const Root = styled(DialogMui)({
  "& .MuiDialog-paper": {
    width: "100%",
    maxHeight: "calc(100% - 4rem)",
    maxWidth: "37.5rem",
    borderRadius: "6px",
    margin: "2rem",
    padding: "2rem",
  },
})

interface IProps extends Omit<DialogProps, "onClose"> {
  onClose: () => void
}

export const Dialog = ({ children, ...rest }: IProps) => (
  <Root {...rest}>
    <Box
      component="header"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      pb="1.5rem"
    >
      <DialogTitle fontSize="1.3rem" fontWeight="600" fontFamily="Inter" sx={{ p: 0 }}>
        {rest.title}
      </DialogTitle>

      <IconButton onClick={rest.onClose}>
        <IoClose />
      </IconButton>
    </Box>

    {children}
  </Root>
)
